// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Container-module__frame-Container--pQtPd {
  width: var(--layout-width);
  margin: 0 auto;
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/frames/Container/Container.module.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".frame-Container {\n  width: var(--layout-width);\n  margin: 0 auto;\n  text-align: left;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"frame-Container": `Container-module__frame-Container--pQtPd`
};
export default ___CSS_LOADER_EXPORT___;
